import { render, staticRenderFns } from "./Shortener.vue?vue&type=template&id=af3cda96&scoped=true&"
import script from "./Shortener.vue?vue&type=script&lang=js&"
export * from "./Shortener.vue?vue&type=script&lang=js&"
import style0 from "./Shortener.vue?vue&type=style&index=0&id=af3cda96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3cda96",
  null
  
)

export default component.exports